import "./SinglePostTemplate.module.css"
import Header from "@/reusable_sections/Header"
import News from "./sections/News"
import Footer from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <Header />
      <News />
      <Footer />
    </div>
  )
}
